export default {
  data() {
    return {
      utilMixin_data: {
        timeSelectStartTmp: null,
        timeSelectEndTmp: null,
      },
    };
  },
  methods: {
    /**
     * 線量値に応じて設定した範囲内のカラーコードを返す
     * @param {object} component - ementUIのTimePickerが渡される
     */
    $_utilMixin_blurTimeSelectForStart(component) {
      // 手動入力の場合は処理する
      if (!this.utilMixin_data.timeSelectStartTmp) {
        const val = this.$_utilMixin_getTimeSelectVal(component);
        this.datetimeSet.timeStart = val;
      }
      // 判定用の値を初期化
      this.utilMixin_data.timeSelectStartTmp = null;
    },
    $_utilMixin_blurTimeSelectForEnd(component) {
      if (!this.utilMixin_data.timeSelectEndTmp) {
        const val = this.$_utilMixin_getTimeSelectVal(component);
        this.datetimeSet.timeEnd = val;
      }
      this.utilMixin_data.timeSelectEndTmp = null;
    },
    /**
     * 該当コンポーネントの内部データからinput値をとり
     * 00 or 30分以外の場合はそれを返す
     * @returns {string}
     */
    $_utilMixin_getTimeSelectVal(component) {
      const originVal = component.picker.value;
      let returnVal = null;
      // 時刻書式チェック 00:00 - 23:59
      if (/(0[0-9]{1}|1{1}[0-9]{1}|2{1}[0-3]{1}):(0[0-9]{1}|[1-5]{1}[0-9]{1})$/.test(originVal)) {
        const min = RegExp.$2 + '';
        if (/^00|30$/.test(min)) {
          returnVal = component.valueOnOpen;
        } else {
          returnVal = originVal;
        }
      } else {
        // 時刻仕様にマッチしない場合はコンポーネントの値を利用
        returnVal = component.valueOnOpen;
      }
      return returnVal;
    },
    /**
     * changeはblurのタイミングの前なのとselectが選択された際にしか実行されないので
     * selectから選ばれた場合はここに一旦値を代入して、blurのタイミングでselectから
     * 選ばれたかどうかを判定する
     * @param {string} val - 選択された値 09:00
     */
    $_utilMixin_changeTimeSelectForStart(val) {
      this.utilMixin_data.timeSelectStartTmp = val;
    },
    $_utilMixin_changeTimeSelectForEnd(val) {
      this.utilMixin_data.timeSelectEndTmp = val;
    },
  },
};
